import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app.jsx';
import { Provider } from 'react-redux';
import AppStore from './app-store';

const domNode = document.getElementById( 'app-root' );
const root = createRoot( domNode );

root.render(
    <Provider store={ AppStore }>
        <App />
    </Provider>
);
